module.exports = __webpack_public_path__ + "img/Busbuddy0.33f04c2e.jpg";